module.exports = __webpack_public_path__ + "static/media/13.5566c568.gif";